
































import { Component, Mixins, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../../../Mixins/ModelSetter";
import TimePickerInput from '../../../../../../components/Pi/fields/TimePickerInput/TimePickerInput.vue';
import { TimeInterval } from "./TimeInterval";

@Component({
  components: {
    TimePickerInput
  }
})
export default class TimeIntervalSetting extends Mixins(ModelSetter) {
  @VModel() model!: TimeInterval

  get from() {
    return this.model.values[0]
  }

  set from(value: string) {
    this.model.values.splice(0, 1, value)
  }

  get to() {
    return this.model.values[1]
  }

  set to(value: string) {
    this.model.values.splice(1, 1, value)
  }
}
